'use strict';
//code from credit-card-type library - A library for determining credit card type --> https://github.com/braintree/credit-card-type/blob/master/index.js

export default () => {
  'ngInject';

  var types = {};
  var VISA = 'visa';
  var MASTERCARD = 'master-card';
  var AMERICAN_EXPRESS = 'american-express';

  var CVV = 'CVV';
  var CID = 'CID';
  var CVC = 'CVC';

  var testOrder = [
    VISA,
    MASTERCARD,
    AMERICAN_EXPRESS
  ];

  types[VISA] = {
    niceType: 'Visa',
    type: VISA,
    prefixPattern: /^4$/,
    exactPattern: /^4\d*$/,
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: CVV,
      size: 3
    }
  };

  types[MASTERCARD] = {
    niceType: 'MasterCard',
    type: MASTERCARD,
    prefixPattern: /^(5|5[1-5]|2|22|222|222[1-9]|2[3-6]|27[0-1]|2720)$/,
    exactPattern: /^(5[1-5]|222[1-9]|2[3-6]|27[0-1]|2720)\d*$/,
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: CVC,
      size: 3
    }
  };

  types[AMERICAN_EXPRESS] = {
    niceType: 'American Express',
    type: AMERICAN_EXPRESS,
    prefixPattern: /^(3|34|37)$/,
    exactPattern: /^3[47]\d*$/,
    isAmex: true,
    gaps: [4, 10],
    lengths: [15],
    code: {
      name: CID,
      size: 4
    }
  };

  function creditCardType(cardNumber) {
    var type, value, i;
    var prefixResults = [];
    var exactResults = [];

    if (!(typeof cardNumber === 'string' || cardNumber instanceof String)) {
      return [];
    }

    for (i = 0; i < testOrder.length; i++) {
      type = testOrder[i];
      value = types[type];

      if (cardNumber.length === 0) {
        prefixResults.push(value);
        continue;
      }

      if (value.exactPattern.test(cardNumber)) {
        exactResults.push(value);
      } else if (value.prefixPattern.test(cardNumber)) {
        prefixResults.push(value);
      }
    }

    return exactResults.length ? exactResults : prefixResults;
  }

  return {
    cardType: creditCardType
  };
};



// WEBPACK FOOTER //
// ./app/src/components/pay_modal/credit_card_type.service.js